import React from "react";
import { Input } from "../ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Search } from "lucide-react";
import { LOCATIONS, ROLES } from "../../constants";

const sel = "bg-vault-panel border-white/10 text-vault-cream h-11";

export const UserFilters = ({ q, setQ, role, setRole, loc, setLoc, canFilterLoc }) => (
  <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
    <div className="relative">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-vault-subtle" />
      <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name or email" className="bg-vault-panel border-white/10 text-vault-cream pl-9 h-11" data-testid="users-search-input" />
    </div>
    <Select value={role} onValueChange={setRole}>
      <SelectTrigger className={sel} data-testid="users-role-filter"><SelectValue placeholder="Role" /></SelectTrigger>
      <SelectContent><SelectItem value="all">All roles</SelectItem>{ROLES.map((r) => <SelectItem key={r} value={r}>{r}</SelectItem>)}</SelectContent>
    </Select>
    {canFilterLoc && (
      <Select value={loc} onValueChange={setLoc}>
        <SelectTrigger className={sel} data-testid="users-location-filter"><SelectValue placeholder="Location" /></SelectTrigger>
        <SelectContent><SelectItem value="all">All locations</SelectItem>{LOCATIONS.map((l) => <SelectItem key={l} value={l}>{l}</SelectItem>)}</SelectContent>
      </Select>
    )}
  </div>
);
